import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=1fb59e72&scoped=true&"
var script = {}
import style0 from "./alert.vue?vue&type=style&index=0&id=1fb59e72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb59e72",
  null
  
)

export default component.exports